import { render } from "./App.vue?vue&type=template&id=79aadb33"
import script from "./App.vue?vue&type=script&scoped=true&lang=js"
export * from "./App.vue?vue&type=script&scoped=true&lang=js"

import exportComponent from "D:\\workspace\\mypage\\mypage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__